import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        {/* 1 */}
        <div className="main_box1">
          <Link to="/shop" onClick={toTop}>
            <img alt="" src="/main/main1.webp" />
          </Link>
        </div>

        {/* 2 */}
        <section className="main_products">
          <div className="container products-header">
            <nav className="product-tabs" aria-label="Product categories">
              <a href="#whats-new" className="active">
                What's New
              </a>
            </nav>

            <Link to="/shop" onClick={toTop} className="view-all">
              VIEW ALL
            </Link>
          </div>

          <div className="container products-row">
            {productData.slice(0, 5).map((p) => {
              const sale = Number(p.price);
              const original = p.originalPrice
                ? Number(p.originalPrice)
                : Number((sale * 1.2).toFixed(2));
              const discount =
                original > sale ? Math.round((1 - sale / original) * 100) : 0;

              return (
                <div key={p.id} className="mini-card">
                  <Link
                    to={`/shopDetails/${p.id}`}
                    onClick={toTop}
                    className="mini-image-link"
                  >
                    <div className="mini-image-wrap">
                      {discount > 0 && (
                        <span className="mini-badge">-{discount}%</span>
                      )}
                      <img src={p.image} alt={p.name} />
                    </div>
                  </Link>

                  <div className="mini-meta">
                    <h4 className="mini-title">
                      <Link to={`/shopDetails/${p.id}`} onClick={toTop}>
                        {p.name}
                      </Link>
                    </h4>
                    <div className="mini-price">
                      <span className="mini-original">
                        ${original.toFixed(2)}
                      </span>
                      <span className="mini-sale">${sale.toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* 3 */}
        <section className="main_hero">
          <div className="container hero-inner">
            <div className="hero-left">
              <p className="eyebrow">A Statement Woven In Style</p>
              <h2 className="hero-title">Cartnovabin</h2>
              <p className="hero-copy">
                Born from the vibrant spirit of Cartnovabin Town, South Africa,
                Cartnovabin creates footwear that embodies confidence,
                individuality, and modern femininity. Known for our
                statement-making silhouettes and refined details, each design is
                crafted to elevate everyday moments with effortless elegance and
                lasting comfort.
              </p>
              <p className="hero-copy small">
                Cartnovabin is where bold style meets thoughtful design made to
                move with you.
              </p>
            </div>

            <div className="hero-right">
              <Link to="/shop" className="hero-card" onClick={toTop}>
                <div className="card-image">
                  <img src="/main/main2-1.webp" alt="Shop Boots" />
                </div>
                <div className="card-meta">
                  <h4>Shop Boots</h4>
                </div>
                <div className="card-action">↗</div>
              </Link>

              <Link to="/shop" className="hero-card" onClick={toTop}>
                <div className="card-image">
                  <img src="/main/main2-2.webp" alt="Shop Heels" />
                </div>
                <div className="card-meta">
                  <h4>Shop Heels</h4>
                </div>
                <div className="card-action">↗</div>
              </Link>

              <Link to="/shop" className="hero-card" onClick={toTop}>
                <div className="card-image">
                  <img src="/main/main2-3.webp" alt="New Arrivals" />
                </div>
                <div className="card-meta">
                  <h4>New Arrivals</h4>
                </div>
                <div className="card-action">↗</div>
              </Link>
            </div>
          </div>
        </section>

        {/* 4 */}
        <section className="testimonials">
          <div className="">
            <div className="testimonials-header">
              <h3>What Our Customers Are Saying</h3>

              <div className="testimonials-meta">
                <div className="rating">
                  <span className="stars">★★★★★</span>
                  <span className="stars empty">☆</span>
                </div>
                <div className="reviews-count">from 3032 reviews</div>
              </div>
            </div>

            <div className="testimonials-row">
              <div className="cards-wrap" role="list">
                {[
                  {
                    title: "Fast delivery",
                    text: "The boots are very comfortable and arrived faster than expected. Quality is great for the price.",
                    author: "Tenesia Robinson",
                    product: "Ashleigh Cargo Pant...",
                  },
                  {
                    title: "Love",
                    text: "So comfortable. I love the plush of the insole and the heel height feels perfect.",
                    author: "Chai",
                    product: "Lamb Statement Poi...",
                  },
                  {
                    title: "Love it",
                    text: "Exactly what I wanted — great finish and attention to detail.",
                    author: "Cheche Channel",
                    product: "Mabelle Ankle Strap ...",
                  },
                  {
                    title: "PERFECTION",
                    text: "LOVED, LOVED, LOVED EXACTLY AS PICTURED. Customer service was great too.",
                    author: "QUE",
                    product: "Free Return Shipping...",
                  },
                  {
                    title: "Gorgeous",
                    text: "Equally gorgeous in person and very comfortable! True to size.",
                    author: "Givonna",
                    product: "Viv Rhinestone And ...",
                  },
                ].map((r, i) => (
                  <article key={i} className="testimonial-card" role="listitem">
                    <div className="card-inner">
                      <div className="card-stars">★★★★★</div>
                      <h4 className="card-title">{r.title}</h4>
                      <p className="card-text">{r.text}</p>
                      <div className="card-meta">
                        <strong>{r.author}</strong>
                        <span className="card-product">{r.product}</span>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 5 */}
        <section className="social-gallery">
          <div className="container">
            <ul className="benefits">
              <li>
                <span className="pill-icon">🚚</span> Free Shipping
              </li>
              <li>
                <span className="pill-icon">🔒</span> Money Guarantee
              </li>
              <li>
                <span className="pill-icon">💳</span> Flexible Payment
              </li>
              <li>
                <span className="pill-icon">↩️</span> Return within 30 days
              </li>
            </ul>

            <div className="gallery-grid">
              {[
                "/main/main3-1.jpg",
                "/main/main3-2.jpg",
                "/main/main3-3.jpg",
                "/main/main3-4.jpg",
                "/main/main3-5.jpg",
                "/main/main3-6.jpg",
                "/main/main3-7.jpg",
                "/main/main3-8.jpg",
                "/main/main3-9.jpg",
                "/main/main3-10.jpg",
              ].map((src, idx) => (
                <div className="gallery-item" key={idx}>
                  <img src={src} alt={`gallery-${idx}`} />
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
